import React from 'react'
import { Text as PDFText, StyleSheet } from '@react-pdf/renderer'

interface Props {
    children: string
    size?: 'xs' | 'sm' | 'base' | 'md' | 'lg' | 'xl'
    fontWeight?: 'normal' | 'semibold' | 'bold' | 'extrabold' | 'black'
    color?: string
}

export const Text: React.FC<Props> = ({
    children,
    size = 'md',
    fontWeight = 'normal',
    color = 'black',
}) => (
    <PDFText
        style={{
            color,
            fontWeight,
            fontFamily: 'Inter',
            lineHeight: 1.4,
            ...styles[size],
        }}
    >
        {children}
    </PDFText>
)

const styles = StyleSheet?.create({
    xs: {
        fontSize: '10px',
    },
    sm: {
        fontSize: '12px',
    },
    base: {
        fontSize: '14px',
    },
    md: {
        fontSize: '16px',
    },
    lg: {
        fontSize: '20px',
    },
    xl: {
        fontSize: '24px',
    },
})
